class HttpMethodsToSdfEnum {
    static GET = 'in-progress';
    static POST = 'complete';
    static PUT = 'changed';
    static DELETE = 'failed';
    static PATCH = 'default';
    static HEAD = 'new'
}

export {HttpMethodsToSdfEnum}